import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const CheckBigIcon: FC<IconProps> = ({ size = 16, color = 'currentColor', colorAlt = 'white' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M0 8C0 3.584 3.584 0 8 0C12.416 0 16 3.584 16 8C16 12.416 12.416 16 8 16C3.584 16 0 12.416 0 8ZM4.28007 8.75875L6.30999 11.0223C6.68342 11.4388 7.28665 11.4388 7.66008 11.0117L11.7199 6.48448C12.0934 6.06807 12.0934 5.39539 11.7199 4.97898C11.3465 4.56256 10.7433 4.56256 10.3698 4.97898L6.98025 8.75875L5.63016 7.25325C5.25673 6.83683 4.6535 6.83683 4.28007 7.25325C3.90664 7.66966 3.90664 8.34234 4.28007 8.75875Z'
          fill={color} />
    <path
      d='M6.30999 11.0224L4.28007 8.75877C3.90664 8.34236 3.90664 7.66968 4.28007 7.25327C4.6535 6.83685 5.25673 6.83685 5.63016 7.25327L6.98025 8.75877L10.3698 4.979C10.7433 4.56258 11.3465 4.56258 11.7199 4.979C12.0934 5.39541 12.0934 6.06809 11.7199 6.4845L7.66008 11.0117C7.28665 11.4388 6.68342 11.4388 6.30999 11.0224Z'
      fill={colorAlt} />
  </svg>
)

export default CheckBigIcon
